import { createFileRoute } from '@tanstack/react-router';

import { ExportRulesPage } from '~/modules/exportRules/ExportRulesPage';
import { LoadingPage } from '~/modules/router/components';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.exportRules.pageTitle, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/settings/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/settings/',
    ...routeParams,
  }),
  component: ExportRulesPage,
  head: () => getRouteHead(title),
  pendingComponent: LoadingPage,
  staticData: {
    AppBar: {
      title,
    },
  },
  wrapInSuspense: true,
});

// fallow-ignore-next-line unused-export -- route export consumed by route registration tooling
export const INVOICE_SETTINGS = buildRouteExport({
  Route,
  ...routeParams,
});
